import React, { useState, useEffect, useCallback } from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";
import Cookies from "js-cookie";

function MembershipEmployee() {
  const ID = Cookies.get("log_id");

  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // const [nextPage, setNextPage] = useState(null);
  // const [prevPage, setPrevPage] = useState(null);
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [showModalRejection, setShowModalRejection] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [rejectionReason, setRejectionReason] = useState("");

  const fetchEmployees = useCallback(
    async (pageUrl = `${url.path}/telecaller-details/`) => {
      try { 
        const response = await axios.get(pageUrl, { params: { login_id: ID } });
        console.log("Data:",response.data);
        setEmployees(response.data.employees);
        setFilteredEmployees(response.data.employees);
        // setNextPage(response.data.next);
        // setPrevPage(response.data.previous);
      } catch (error) { 
        console.error("Error fetching employees:", error);
        setEmployees([]);
        setFilteredEmployees([]);
      }
    },
    [ID]
  );

  useEffect(() => {
    if (ID) {
      fetchEmployees();
    }
  }, [ID, fetchEmployees]);

  // Function to handle payment submission
  const handlePayment = async () => {
    if (!selectedEmployee || !selectedEmployee.id) {
      alert("Please select an employee before proceeding with the payment.");
      return;
    }

    const employeePayment = paymentDetails[selectedEmployee.id];

    if (!employeePayment?.method || !employeePayment?.amount) {
      alert("Payment method and amount are required.");
      return;
    }

    try {
      const response = await axios.patch(`${url.path}/process-payment/`, {
        login_id: ID,
        employee_id: selectedEmployee.id,
        payment_method: employeePayment.method,
        amount: employeePayment.amount,
        payment_info: employeePayment.info || "",
      });
      console.log("Payment response:", response.data);
      alert(`Payment successful via ${employeePayment.method}`);

      //new statemnt
      setEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === selectedEmployee.id
            ? {
                ...emp,
                payment_method: employeePayment.method,
                payment_amount: employeePayment.amount,
                payment_info: employeePayment.info || "",
              }
            : emp
        )
      );

      setShowModalPayment(false);
      setPaymentDetails((prev) => ({
        ...prev,
        [selectedEmployee.id]: { method: "", amount: "", info: "" },
      }));
    } catch (error) {
      console.error("Payment failed:", error);

      const errorMessage =
        error.response?.data?.message || "Payment failed. Please try again.";
      alert(errorMessage);
    }
  };

  const handleStatusChange = async (employeeId, newStatus) => {
    //new statment
    const employee = employees.find((emp) => emp.id === employeeId);
    if (newStatus === "Approved") {
      if (
        !employee.payment_method || 
        !employee.payment_amount
      ) {
        alert("Please complete the payment before approving.");
        return;
      }
    }

    try {
      await axios.patch(`${url.path}/update-MembershipEmployeeCompany/`, {
        login_id: ID,
        employee_id: employeeId,
        status: newStatus,
      });

      setEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === employeeId ? { ...emp, status: newStatus } : emp
        )
      );
      setFilteredEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === employeeId ? { ...emp, status: newStatus } : emp
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // Function to handle rejection (opens modal)
  const handleReject = (employee) => {
    setSelectedEmployee(employee);
    setShowModalRejection(true);
  };

  // Function to submit rejection reason
  const submitRejection = async () => {
    if (!rejectionReason.trim()) {
      alert("Please enter a rejection reason.");
      return;
    }

    try {
      await axios.delete(`${url.path}/update-MembershipEmployeeCompany/`, {
        data: {
          login_id: ID,
          employee_id: selectedEmployee.id,
          reason: rejectionReason,
        },
      });

      setEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === selectedEmployee.id
            ? {
                ...emp,
                status: "Rejected",
                reasonForRejection: rejectionReason,
              }
            : emp
        )
      );

      setFilteredEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === selectedEmployee.id
            ? {
                ...emp,
                status: "Rejected",
                reasonForRejection: rejectionReason,
              }
            : emp
        )
      );

      setShowModalRejection(false);
      setRejectionReason("");
    } catch (error) {
      console.error("Error rejecting employee:", error);
    }
  };

  return (
    <div>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Membership
        </h3>
      </center>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => {
            const value = e.target.value.toLowerCase();
            setSearchTerm(value);
            // const filtered = employees.filter(
            //   (emp) =>
            //     emp.name.toLowerCase().includes(value) ||
            //     emp.email.toLowerCase().includes(value) ||
            //     emp.contact.toLowerCase().includes(value)
            // );
            const filtered = employees.filter((emp) =>
              (emp.name?.toLowerCase() || "").includes(value) ||
              (emp.email?.toLowerCase() || "").includes(value) ||
              (emp.contact?.toLowerCase() || "").includes(value)
            );
            setFilteredEmployees(filtered);
          }}
          placeholder="Search by name, email, or contact..."
          className="search-input"
          style={{
            width: "250px",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        />
      </div>

      <div className="table-container">
        <table className="responsive-table" id="productstable">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-4 py-2">Name</th>
              <th className="border border-gray-300 px-4 py-2">Email</th>
              <th className="border border-gray-300 px-4 py-2">
                Package Taken
              </th>
              <th className="border border-gray-300 px-4 py-2">Payment</th>
              <th className="border border-gray-300 px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmployees && filteredEmployees.length > 0 ? (
              filteredEmployees.map((employee) => (
                <tr key={employee.id}>
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.name}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.email}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.package_taken}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <button
                      onClick={() => {
                        setSelectedEmployee(employee);
                        setShowModalPayment(true);
                      }}
                    //   className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-700 "
                    // >
                    className={`px-4 py-2 text-white rounded-md ${
                      employee.status === "Approved" || employee.status === "Rejected"
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-500 hover:bg-green-700"
                    }`}
                    disabled={employee.status === "Approved" || employee.status === "Rejected"}
                  >
                      Pay
                    </button>
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.status === "Approved" ? (
                      <button className="px-4 py-2 bg-green-500 text-white rounded-md cursor-not-allowed">
                        Approved
                      </button>
                    ) : employee.status === "Rejected" ? (
                      <button className="px-4 py-2 bg-red-500 text-white rounded-md cursor-not-allowed">
                        Rejected
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={() =>
                            handleStatusChange(employee.id, "Approved")
                          }
                          className="px-2 py-1 bg-blue-500 text-white rounded-md mx-1 hover:bg-blue-700"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => handleReject(employee)}
                          className="px-2 py-1 bg-red-500 text-white rounded-md mx-1 hover:bg-red-700"
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-2">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Payment */}
      {showModalPayment && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-bold mb-4">
              Select Payment Method for {selectedEmployee?.name}
            </h2>

            <select
              value={paymentDetails[selectedEmployee?.id]?.method || ""}
              onChange={(e) =>
                setPaymentDetails((prev) => ({
                  ...prev,
                  [selectedEmployee.id]: {
                    ...prev[selectedEmployee.id],
                    method: e.target.value,
                    info: "",
                  },
                }))
              }
              className="w-full p-2 border rounded-md mb-3"
            >
              <option value="">Select Payment Method</option>
              <option value="UPI">UPI</option>
              <option value="Cash">Cash</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Cheque">Cheque</option>
            </select>

            <input
              type="number"
              placeholder="Enter Amount"
              value={paymentDetails[selectedEmployee?.id]?.amount || ""}
              onChange={(e) =>
                setPaymentDetails((prev) => ({
                  ...prev,
                  [selectedEmployee.id]: {
                    ...prev[selectedEmployee.id],
                    amount: e.target.value,
                  },
                }))
              }
              className="w-full p-2 border rounded-md mb-3"
            />

            {paymentDetails[selectedEmployee?.id]?.method === "UPI" && (
              <input
                type="text"
                placeholder="Enter UPI Number"
                value={paymentDetails[selectedEmployee?.id]?.info || ""}
                onChange={(e) =>
                  setPaymentDetails((prev) => ({
                    ...prev,
                    [selectedEmployee.id]: {
                      ...prev[selectedEmployee.id],
                      info: e.target.value,
                    },
                  }))
                }
                className="w-full p-2 border rounded-md mb-3"
              />
            )}
            {paymentDetails[selectedEmployee?.id]?.method ===
              "Bank Transfer" && (
              <input
                type="text"
                placeholder="Enter Bank Account Number"
                value={paymentDetails[selectedEmployee?.id]?.info || ""}
                onChange={(e) =>
                  setPaymentDetails((prev) => ({
                    ...prev,
                    [selectedEmployee.id]: {
                      ...prev[selectedEmployee.id],
                      info: e.target.value,
                    },
                  }))
                }
                className="w-full p-2 border rounded-md mb-3"
              />
            )}
            {paymentDetails[selectedEmployee?.id]?.method === "Cheque" && (
              <input
                type="text"
                placeholder="Enter Cheque Number"
                value={paymentDetails[selectedEmployee?.id]?.info || ""}
                onChange={(e) =>
                  setPaymentDetails((prev) => ({
                    ...prev,
                    [selectedEmployee.id]: {
                      ...prev[selectedEmployee.id],
                      info: e.target.value,
                    },
                  }))
                }
                className="w-full p-2 border rounded-md mb-3"
              />
            )}

            <div className="flex justify-end mt-4">
              <button
                onClick={() => setShowModalPayment(false)}
                className="px-4 py-2 bg-gray-400 text-white rounded-md mx-2 hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={() => handlePayment(selectedEmployee.id)}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-700"
                disabled={
                  !paymentDetails[selectedEmployee?.id]?.amount ||
                  (!paymentDetails[selectedEmployee?.id]?.info &&
                    paymentDetails[selectedEmployee?.id]?.method !== "Cash")
                }
              >
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Rejection Modal */}

      {showModalRejection && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-5 rounded-md shadow-lg w-96">
            <h2 className="text-lg font-bold mb-2">Reason for Rejection</h2>
            <textarea
              className="w-full p-2 border rounded-md"
              rows="3"
              placeholder="Enter rejection reason"
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            ></textarea>
            <div className="flex justify-end mt-3">
              <button
                onClick={() => setShowModalRejection(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded-md mx-2 hover:bg-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={submitRejection}
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {/* <div className="flex justify-center mt-4">
        {prevPage && (
          <button
            onClick={() => fetchEmployees(prevPage)}
            className="px-4 py-2 bg-gray-500 text-white rounded-md mx-2 hover:bg-gray-700"
          >
            Previous
          </button>
        )}
        {nextPage && (
          <button
            onClick={() => fetchEmployees(nextPage)}
            className="px-4 py-2 bg-blue-500 text-white rounded-md mx-2 hover:bg-blue-700"
          >
            Next
          </button>
        )}
      </div> */}
    </div>
  );
}

export default MembershipEmployee;
